import { render, staticRenderFns } from "./AsideMyTeamSection.vue?vue&type=template&id=5b01f6cc&"
import script from "./AsideMyTeamSection.vue?vue&type=script&lang=js&"
export * from "./AsideMyTeamSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports